import React from "react";
import { scoreToImpl } from "@/lib/implementation";

export function ImplementationStatusBadge({ valueScore }: { valueScore: number | null | undefined }) {
  const label = scoreToImpl(valueScore);

  let bgColor = "bg-gray-300";
  if (label === "Implemented") bgColor = "bg-green-600";
  if (label === "Partially Implemented") bgColor = "bg-orange-600";
  if (label === "Not Implemented") bgColor = "bg-red-500";

  return (
    <span
      className={`${bgColor} text-white px-3 py-1 rounded-md text-sm font-medium`}
    >
      {label || "—"}
    </span>
  );
}